import React from 'react'
import Header3 from '../../Globle/Header3'
import SmallNav from '../MainHomeThree/SmallNav'
import Banner from '../MainHomeThree/Banner'
import Service from '../MainHomeThree/Service'
import Catageory from '../MainHomeThree/Catageory'
import NewArrival from '../MainHomeThree/NewArrival'
import Branding from '../MainHomeThree/Branding'
import BestProdect from '../MainHomeThree/BestProdect'
import Modren from '../MainHomeThree/Modren'
import Offer from '../MainHomeThree/Offer'
import Testimonial from '../MainHomeThree/Testimonial'
import Clint from '../MainHomeThree/Clint'
import Blog from '../MainHomeThree/Blog'
import Prodectslider from '../MainHomeThree/Prodectslider'
import Footer from '../../Globle/Footer3'

const Main = () => {
    return (
        <>
            <Header3 />
            <SmallNav />
            <Banner />
            <Service />
            <Catageory />
            <NewArrival />
            <Branding />
            <BestProdect />
            <Modren />
            <Offer />
            <Testimonial />
            <Clint />
            <Blog />
            <Prodectslider />
            <Footer />
        </>
    )
}

export default Main
